import React, {useState} from 'react';
import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import {IRuleViolation} from '../../Interfaces/Application/IApplicationQuote';
import { DialogProps } from './DialogProps';
import DialogTitle from "@mui/material/DialogTitle";
import {Checkbox} from "@progress/kendo-react-inputs";
import {hasValue} from "@amsanalytics/react-shared-library";

export interface BypassableErrorDialogProps extends DialogProps<string> {
  errors: (string | IRuleViolation)[];
  allowBypass?: boolean;
  bodyText: string;
  confirmationCheckboxText?: string;
}
export default function BypassableErrorDialog(props: BypassableErrorDialogProps) {
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const showCheckbox = hasValue(props.confirmationCheckboxText);
  const preventBypassingDueToCheckbox = showCheckbox && !checkboxChecked;
  
  return (
    <div style={{maxWidth: "500px"}}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.bodyText}</DialogContentText>
        <ul>
          {props.errors.map((e, i) => (
            <li key={i} style={{ color: typeof e !== 'string' && e.type === 'error' ? 'red' : 'black' }}>
              {typeof e === 'string' ? e : e.message}
            </li>
          ))}
        </ul>
        {props.allowBypass === true && <DialogContentText>Would you like to bypass these requirements?</DialogContentText>}
        {showCheckbox &&
          <div style={{marginTop: "10px"}}>
            <Checkbox
              label={props.confirmationCheckboxText}
              title="Verified"
              checked={checkboxChecked}
              onChange={() => setCheckboxChecked(!checkboxChecked)}
            />
          </div>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={props.closeDialog} color='inherit' autoFocus>
          Cancel
        </Button>
        {props.allowBypass === true && (
          <Button
            disabled={preventBypassingDueToCheckbox}
            onClick={() => {
              props.accept && props.accept("");
              props.closeDialog();
            }}
            color='primary'
          >
            Bypass
          </Button>
        )}
      </DialogActions>
    </div>
  );
}
